import type { CSSProperties, JSX } from 'react';
import frameUrl from '../../shared/assets/avatar-frame.png';
import { BallotSigil } from './BallotSigil.js';

/* Threads the woodcut frame PNG into the mask via the same CSS var AvatarFrame
   uses, so the sentinel wears the identical frame — it really is "an avatar
   frame without a player." */
const FRAME_STYLE = { '--susdle-frame-art': `url(${frameUrl})` } as CSSProperties;

/**
 * The "Another Round" ballot tile — the discussion cast grid's last cell. It
 * reuses AvatarFrame's `.susdle-seat__*` geometry + woodcut frame mask (no CSS
 * of its own beyond the `--sentinel` overrides in CastGrid.css), swapping the
 * portrait for the BallotSigil and the name for a soft-ink wrapping label in
 * the same upright display face every other AvatarFrame label uses. Votable
 * like any other cell — the cast cell wrapping it owns the radio semantics.
 */
export function SentinelTile({ label }: { label: string }): JSX.Element {
  return (
    <div className="susdle-seat susdle-seat--sentinel">
      <div className="susdle-seat__tile" style={FRAME_STYLE}>
        <div className="susdle-seat__content">
          <div className="susdle-seat__avatar-zone">
            <BallotSigil />
          </div>
          <div className="susdle-seat__name-zone">
            <span className="susdle-seat__name">{label}</span>
          </div>
        </div>
        <span aria-hidden className="susdle-seat__frame-art" />
      </div>
    </div>
  );
}
